
import { StyleSheet} from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  
    page: {
        padding: 20,
        fontSize: 9,
        fontFamily: 'Montserrat',
        backgroundColor: '#FFFFFF',
    },

    header: {
        flexDirection: 'row',
        marginBottom: 5
    },
    
    logoContainer: {
        flexGrow: 1
    },
    
    logo: {
        width: '228', // Adjust width as needed
        height: 'auto', // Maintain aspect ratio
    },
    
    title: {
         flexGrow: 1,
         width: '100%',
         textAlign: 'right',
         fontWeight: 'bold',
         fontSize: 14
     },


    swapRow: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: 5,
        marginBottom: 5,
    },

    swapNumberBox: {
        width: 200,
        height: 25,
        border: '1pt solid #CCCCCC',
        flexDirection: 'row',
        alignItems: 'stretch',
    },

    swapNumberLabel: {
        width: 80,
        backgroundColor: '#E8EEF7',
        borderRight: '1pt solid #CCCCCC',
        justifyContent: 'center',
        paddingLeft: 8,
    },

    swapNumberLabelText: {
        fontSize: 10,
        justifyContent: 'center',
        fontWeight: 'bold'
    },

    swapNumberInput: {
        flex: 1,
        backgroundColor: '#FFFFFF',
        justifyContent: 'center',
        paddingLeft: 10,
        paddingRight: 10,
    },

    swapNumberText: {
        fontSize: 10,
    },


  // Section Headers
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#D42027', // NKR Red
    marginTop: 5,
    marginBottom: 8,
  },

  // Table Styles
  table: {
    width: '100%',
    marginBottom: 15,
    borderTop: '1pt solid #CCCCCC',
  },

  tableRow: {
    flexDirection: 'row',
    borderBottom: '1pt solid #CCCCCC',
    
    minHeight: 20,
  },



  // Column Headers (Donor Center / Recipient Center)
  tableHeaderCell: {
    flex: 1,
    padding: 3,
    fontWeight:'bold',
    fontSize: 9,
    color: '#FFFFFF',
    justifyContent: 'center',
  },

  donorHeader: {
    backgroundColor: '#D42027', // Red
  },

  recipientHeader: {
    backgroundColor: '#003A70', // Navy Blue
  },

  // Row Label Cell (left column)
  labelCell: {
    width: '20%',
    padding: 3,
    backgroundColor: '#E6E6E6',
    fontWeight: 'bold',
    fontSize: 9,
    justifyContent: 'center',
    
    borderLeft: '1pt solid #CCCCCC',
    
  },

  // Input Cells
  inputCell: {
    flex: 1,
    padding: 3,
    fontSize: 9,
    justifyContent: 'center',
    borderLeft: '1pt solid #CCCCCC',
    borderRight: '1pt solid #CCCCCC',
  },

  inputCellBorder: {
    flex: 1,
    padding: 3,
    fontSize: 9,
    justifyContent: 'center',
    borderRight: '1pt solid #CCCCCC',
  },


billingSpecificsSection: {
  marginTop: 5,
},

billingSpecificsTitle: {
  fontSize: 12,
  fontWeight: 'bold',
  color: '#D42027', // NKR Red
  marginBottom: 10,
},

billingSpecificsSubtitle: {
  fontSize: 10,
  fontWeight: 'bold',
  color: '#000000',
  marginBottom: 5,
},

billingSpecificsText: {
  fontSize: 9,
  lineHeight: 1.5,
  color: '#000000',
  marginBottom: 10,
},

billingSpecificsLink: {
  color: '#D42027', // Red link color
  textDecoration: 'none',
},

billingParagraph: {
  marginBottom: 10,
},

  
  // Footer Section
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 8,
    color: '#666666',
  },

  
});


